import { createSlice } from '@reduxjs/toolkit'

const snacksSlice = createSlice({
    name: 'snacksList',
    initialState: {
        error: null,
        loading: false,
        snacksListOffer: [],
        snackListToSet: [],
    },
    reducers: {
        loadSnacks(state) {
            state.loading = true
        },
        setSnacks(state, action) {
            const { payload } = action
            state.snacksListOffer = payload
        },
    },
})

const { actions, reducer } = snacksSlice

export const { loadSnacks, setSnacks } = actions

export default reducer
